module.exports = __webpack_public_path__ + "img/thumbnail.a944dff1.png";